import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    creator: '',
    start_date_from: '',
    start_date_to: '',
    status: '',
    student: '',
    category: ''
  },
}

export const meetingsUI = createSlice({
  name: 'meetingsUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setCreator: (state, { payload }) => {
      state.tableFilters.creator = payload
    },
    setStartDateTo: (state, { payload }) => {
      state.tableFilters.start_date_to = payload
    },
    setStartDateFrom: (state, { payload }) => {
      state.tableFilters.start_date_from = payload
    },
    setStatus: (state, { payload }) => {
      state.tableFilters.status = payload
    },
    setStudent: (state, { payload }) => {
      state.tableFilters.student = payload
    },
    setCategory: (state, { payload }) => {
      state.tableFilters.category = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setCreator,
  setStartDateTo,
  setStartDateFrom,
  setStatus,
  setStudent,
  setCategory,
  trackActiveFilters,
  clearAllFilters,
} = meetingsUI.actions

export default meetingsUI.reducer
